import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function RelatedPosts({ currentPost }) {
  const [relatedPosts, setRelatedPosts] = useState([]);

  useEffect(() => {
    if (!currentPost?.user?.username || !currentPost?.tag_list) return;

    const currentTags = Array.isArray(currentPost.tag_list)
      ? currentPost.tag_list
      : typeof currentPost.tag_list === "string"
      ? currentPost.tag_list.split(",").map((t) => t.trim())
      : [];

    const username = currentPost.user.username;

    fetch(`https://dev.to/api/articles?username=${username}&per_page=30`)
      .then((res) => res.json())
      .then((data) => {
        const filtered = data
          .filter((p) => p.id !== currentPost.id)
          .filter((p) => {
            const tags = Array.isArray(p.tag_list)
              ? p.tag_list
              : typeof p.tag_list === "string"
              ? p.tag_list.split(",").map((t) => t.trim())
              : [];

            return tags.some((tag) => currentTags.includes(tag));
          });

        setRelatedPosts(filtered.slice(0, 3));
      });
  }, [currentPost]);

  if (relatedPosts.length === 0) return null;

  return (
    <section className="mt-16">
      <h2 className="text-2xl font-bold text-purple-700 mb-6">
        Take a look at these
      </h2>
      <div className="grid md:grid-cols-3 gap-6">
        {relatedPosts.map((post) => (
          <Link
            key={post.id}
            to={`/post/${post.slug}/${post.id}`}
            className="block bg-white rounded shadow hover:shadow-lg transition overflow-hidden"
          >
            {post.cover_image && (
              <img
                src={post.cover_image}
                alt={post.title}
                className="w-full h-40 object-cover"
              />
            )}
            <div className="p-4">
              <h3 className="font-semibold text-lg text-purple-800 mb-2">
                {post.title}
              </h3>
              <p className="text-sm text-slate-600 line-clamp-3">
                {post.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default RelatedPosts;
